import { Outlet } from "react-router-dom";
const UserProfileLayout = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default UserProfileLayout;
